import React, { useCallback, useState } from "react";
import styled from "@mui/material/styles/styled";
import Grid from "@mui/material/Grid";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { ChangeProgram } from "./ChangeProgram";
import { Button } from "../../Button";
import { Link } from "@mui/material";
const SummaryStyle = styled(Grid)(({ theme }) => {
    const roboto = {
        fontFamily: "Roboto",
        fontSize: 16,
        fontWeight: 500,
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
    };
    return {
        ".pi-summary_title": {
            fontSize: 40,
            fontWeight: "700",
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: 1.1,
            letterSpacing: "normal",
            textAlign: "left",
            color: "#000",
            margin: 0,
        },
        ".pi-summary_subtitle": {
            fontSize: 30,
            color: "#666",
            fontWeight: 200,
            marginBottom: 26,
        },
        ".pi-summary_ViewBrochure": {
            cursor: "pointer",
            fontWeight: "400",
            marginBottom: 26,
            a: {
                textDecoration: 'none',
                color: " rgb(65, 181, 194)",
            }
        },
        '.pi-summary_description': {
            margin: '16px 0',
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
            fontWeight: "300",
            color: "#212529",
        },
        ".pi-progress": {
            ".pi-progress_title": Object.assign(Object.assign({}, roboto), { textAlign: "left", color: "#000", margin: "0 0 20px" }),
            ".pi-progress_subtitle": Object.assign(Object.assign({}, roboto), { fontSize: 15, fontWeight: 400, letterSpacing: 1.2, textAlign: "left", color: "#454d58", marginBottom: 15 }),
            ".pi-progress_container": {
                height: 16,
                width: "100%",
                background: "rgba(235,87,87,.5)",
                // background:'rgba(254,196,101,.5)',
                borderRadius: 50,
                ".pi-progress_inidicator": {
                    backgroundColor: "#eb5757",
                    height: "100%",
                    borderRadius: 50,
                    textAlign: "right",
                    ".MuiSvgIcon-root": {
                        fill: "currentColor",
                        width: "1em",
                        height: "1em",
                        display: "inline-block",
                        transition: "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                        flexShrink: 0,
                        userSelect: "none",
                        marginTop: 2,
                    },
                },
            },
            ".pi-progress_amount-wrapper": {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: 10,
                ".pi-progress_met": Object.assign(Object.assign({}, roboto), { textAlign: "center", color: "#eb5757" }),
                ".pi-progress_reamaining": {
                    fontSize: 14,
                    fontWeight: 400,
                    textAlign: "center",
                    color: "#000",
                    fontFamily: "Roboto",
                },
            },
        },
        ".change-program button": {
            fontSize: 20,
            border: "2px solid #41b5c2",
            color: "#41b5c2 !important",
            borderRadius: 30,
            fontFamily: "Oswald",
            padding: "4px 15px",
        },
    };
});
// pi-> program information
export const Summary = (props) => {
    const [changeProgram, setChangeProgram] = useState("");
    const updateChangePrgm = useCallback((btn) => {
        return () => {
            console.log("updateChangePrgm INDEX: ", btn);
            setChangeProgram(btn.label);
        };
    }, [changeProgram]);
    return (React.createElement(SummaryStyle, { container: true, className: "pi-summary" },
        React.createElement(Grid, { container: true, xs: 12, spacing: 2 },
            React.createElement(PITitle, Object.assign({}, props.programName)),
            React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                props.headerSumary && React.createElement(PIProgressBar, Object.assign({}, props.headerSumary)),
                props.shareSummary && React.createElement(PIProgressBar, Object.assign({}, props.shareSummary)),
                !props.changeProgram ? null : (React.createElement(ChangeProgram, { modal: changeProgram, setChangeProgram: (data) => setChangeProgram(data), changeProgram: props.changeProgram })))),
        !props.changeProgram ? null : (React.createElement(Grid, { item: true, xs: 12, className: "change-program" },
            React.createElement(Button, Object.assign({}, changePrgrmBtn, { onClick: updateChangePrgm(changePrgrmBtn) }))))));
};
const PITitle = (props) => (React.createElement(Grid, { item: true, xs: 12, sm: 6 },
    React.createElement("h1", { className: "pi-summary_title" }, props.title),
    props.subTitle ? (React.createElement("h2", { className: "pi-summary_subtitle pi-summary_title" }, props.subTitle)) : null,
    (props === null || props === void 0 ? void 0 : props.description) && (React.createElement("p", { className: "pi-summary_description" }, props.description)),
    (props === null || props === void 0 ? void 0 : props.URL) && React.createElement("p", { className: "pi-summary_ViewBrochure" },
        React.createElement(Link, { target: "_blank", href: props.URL }, "View Brochure"))));
const PIProgressBar = (props) => {
    if (!Object.keys(props).length)
        return null;
    return (React.createElement("div", { className: "pi-progress" },
        React.createElement("h5", { className: "pi-progress_title" }, props.title),
        React.createElement("h6", { className: "pi-progress_subtitle" }, props.subTitle),
        React.createElement("div", { className: "pi-progress_container", style: props.style },
            React.createElement("div", { className: "pi-progress_inidicator", style: {
                    width: props.progress + "%",
                    backgroundColor: props.indicatorColor,
                } },
                React.createElement(ArrowRightAltIcon, { viewBox: "0 6 24 24", style: { color: "#ffffff" } }))),
        React.createElement("div", { className: "pi-progress_amount-wrapper" },
            React.createElement("span", { className: "pi-progress_met" },
                "$",
                numberWithCommas(props.met),
                " met"),
            React.createElement("span", { className: "pi-progress_reamaining" },
                "$",
                numberWithCommas(props.remaining),
                " remaining"))));
};
const numberWithCommas = (data) => {
    return new Intl.NumberFormat("en-us").format(data || 0);
};
const changePrgrmBtn = {
    variant: "outlined",
    label: "Change Program",
    size: "medium",
};
